"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_APP_STANDARD_DATABASE_LAYOUTS = exports.CUSTOM_APP_VIEW_CONFIG_DATABASE_LAYOUT = exports.CUSTOM_APP_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = exports.CUSTOM_APP_DATABASE_LAYOUT_ROW_GAP = exports.CUSTOM_APP_DATABASE_LAYOUT_COLUMN_GAP = exports.CUSTOM_APP_DATABASE_LAYOUT_NODE_HEIGHT = exports.CUSTOM_APP_DATABASE_LAYOUT_NODE_WIDTH = void 0;
exports.serializeCustomAppDatabaseXYWH = serializeCustomAppDatabaseXYWH;
const database_identity_1 = require("@streamlain/database-identity");
exports.CUSTOM_APP_DATABASE_LAYOUT_NODE_WIDTH = database_identity_1.CANVAS_DATABASE_LAYOUT_NODE_WIDTH;
exports.CUSTOM_APP_DATABASE_LAYOUT_NODE_HEIGHT = database_identity_1.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT;
exports.CUSTOM_APP_DATABASE_LAYOUT_COLUMN_GAP = database_identity_1.CANVAS_DATABASE_LAYOUT_COLUMN_GAP;
exports.CUSTOM_APP_DATABASE_LAYOUT_ROW_GAP = database_identity_1.CANVAS_DATABASE_LAYOUT_ROW_GAP;
exports.CUSTOM_APP_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = database_identity_1.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT;
function layout(index, column, row) {
    return (0, database_identity_1.createCanvasDatabaseGridLayout)(index, column, row);
}
exports.CUSTOM_APP_VIEW_CONFIG_DATABASE_LAYOUT = layout('a0', 0, 0);
exports.CUSTOM_APP_STANDARD_DATABASE_LAYOUTS = {
    pages: layout('s0', -1, 1),
    navigation: layout('s1', 0, 1),
    clusters: layout('s2', 1, 1),
    topics: layout('s3', -1, 2),
    content: layout('s4', 0, 2),
    articleBlocks: layout('s5', 1, 2),
    translations: layout('s6', -1, 3),
    forms: layout('s7', 0, 3),
    submissions: layout('s8', 1, 3),
    // sl-sbux.8.1: styling DBs sit on a fourth row so the existing custom-app-tree
    // canvas layout stays untouched. StyleVariants joined the row in the
    // 2026-05-23 amendment — placed right of stylePresets so the relation
    // arrow stays short on the canvas.
    themes: layout('s9', -1, 4),
    motionSpecs: layout('s10', 0, 4),
    stylePresets: layout('s11', 1, 4),
    styleVariants: layout('s12', 2, 4),
    customSheets: layout('s13', 0, 5),
    customHtmlBlocks: layout('s14', 1, 5),
    branding: layout('s15', -1, 6),
    users: layout('s16', 2, 2),
};
function serializeCustomAppDatabaseXYWH(layout) {
    return (0, database_identity_1.serializeCanvasDatabaseXYWH)(layout);
}
